<!--
 * @FileDescription: 审核设置（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-01（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
      <a-modal  :title="title" class="freight-model"  v-model="isShowModel"  @ok="onCofrimForm"  @cancel="onCancel">
        <a-form :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 16 }">
            <a-form-item label="类型">
                <a-select  v-decorator="['type',{ rules: [{ required: true, message: '请选择类型'}] },]"
                           placeholder="请选择类型"
                           :disabled="disabled1"
                            @change="changeType"
                >
                    <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                    <a-select-option value="1">
                        收入
                    </a-select-option>
                    <a-select-option value="2">
                        支出
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="类别编号">
                <a-input placeholder="请输入类别编号" type="number" :minLength="3"  :maxLength="10"   v-decorator="['code', { rules: [{ required: true, message: '请输入类别编号' },{ min: 3, message: '请输入3-10位数字的类别编号' },{ max: 10, message: '请输入3-10位数字的类别编号' }] }]"  />
            </a-form-item>
            <a-form-item label="类别名称">
                <a-input placeholder="请输入类别名称"   v-decorator="['name', { rules: [{ required: true, message: '请输入类别名称' }] }]"  />
            </a-form-item>
        </a-form>
      </a-modal>
      <a-modal  class="freight-model1" :title="title1"   v-model="isShowModel1"  @ok="onCofrimForm1"  @cancel="onCancel">
          <a-form :form="form1"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 16 }">
              <a-form-item label="科目编号">
                  <a-input placeholder="请输入科目编号" type="number" :minLength="3"  :maxLength="10"    v-decorator="['code', { rules: [{ required: true, message: '请输入科目编号' },{ min: 3, message: '请输入3-10位数字的科目编号' },{ max: 10, message: '请输入3-10位数字的科目编号' }] }]"  />
              </a-form-item>
              <a-form-item label="科目名称">
                  <a-input placeholder="请输入科目名称"   v-decorator="['name', { rules: [{ required: true, message: '请输入科目名称' }] }]"  />
              </a-form-item>
              <a-form-item label="科目简称">
                  <a-input placeholder="请输入科目简称"   v-decorator="['nameShort', { rules: [{ required: false, message: '请输入科目名称' }] }]"  />
              </a-form-item>
              <a-form-item label="状态">
                  <a-radio-group name="radioGroup"
                                 v-decorator="['openFlag', { rules: [{ required: false }] }]"
                                 >
                      <a-radio value="1">启用</a-radio>
                      <a-radio value="0">停用</a-radio>
                  </a-radio-group>
              </a-form-item>
              <a-form-item label="备注">
                  <a-input placeholder="请输入备注"   v-decorator="['remark', { rules: [{ required: false, message: '请输入科目名称' }] }]"  />
              </a-form-item>
          </a-form>
      </a-modal>
      <a-modal  class="freight-model2" :title="title2"   v-model="isShowModel2"  @ok="onCofrimForm2"  @cancel="onCancel">
          <a-form :form="form2"
                  :label-col="{ span: 8 }"
                  :wrapper-col="{ span: 16 }">
              <a-form-item label="起始日期">
                  <a-date-picker   v-decorator="['startTime', {rules: [{ type: 'object', required: true, message: '请选择起始日期' }]}]"
                                   style="width: 220px"
                                   @change="changeDate"
                                   placeholder="请选择起始日期"/>
              </a-form-item>
              <a-form-item label="截止日期">
                  <a-date-picker   v-decorator="['endTime', {rules: [{ type: 'object', required: true, message: '请选择截止日期' }]}]"
                                   style="width: 220px"
                                   :disabled-date="disabledEndDate"
                                   @change="changeDate1"
                                   placeholder="请选择截止日期"/>
              </a-form-item>
          </a-form>
      </a-modal>
      <a-modal  class="freight-model3" :title="title3"   v-model="isShowModel3"  @ok="onCofrimForm3"  @cancel="onCancel">
          <a-form :form="form3"
                  :label-col="{ span: 6 }"
                  :wrapper-col="{ span: 16 }">
              <a-form-item label="期初金额">
                  <a-input placeholder="请输入金额" type="number"  v-decorator="['initialBalance', { rules: [{ required: true, message: '请输入金额' }] }]"  />
              </a-form-item>
          </a-form>
      </a-modal>
  </div>
</template>
<script>
import {financeAdd,financeUpdate,finceaccountsave,finceaccountupdate,updatebalance} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from 'moment';
import pick from 'lodash.pick'
export default {
    mixins:[mixins],
    props:{
        auditItem:{
            type:Object,
        }
    },
    data(){
        return{
            title:'新增收支类别',
            isShowModel:false,
            form: this.$form.createForm(this),
            title1:'新增现金银行',
            isShowModel1:false,
            form1: this.$form.createForm(this),
            title2:'科目明细账',
            isShowModel2:false,
            form2: this.$form.createForm(this),
            title3:'修改期初',
            isShowModel3:false,
            form3: this.$form.createForm(this),
            model:{},
            datetime:'',
            datetime1:'',
            disabled1:false,
            inCode:'',
            outCode:'',
        }
    },
    watch: {

    },
    mounted () {

    },
    created () {

    },
    components: {
        AFormItem,
        ATextarea
    },
    methods: {
        moment,
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onOpen(index,record,index1,inCode,outCode){
            this.model = {}
            if(index == 1){
                if(index1 == 1){
                    this.title = '新增收支类别'
                    this.form =  this.$form.createForm(this)
                    this.disabled1 = false
                    
                    this.inCode = inCode
                    this.outCode = outCode
                }else{
                    this.title = '编辑收支类别'
                    this.form =  this.$form.createForm(this)
                    this.model = Object.assign({},record)
                    this.$nextTick(() => {
                        this.form.setFieldsValue(pick(this.model,'code','name','type','id'))
                    });
                    this.disabled1 = true
                }
                this.isShowModel = true
            }else if(index == 2){

            }else if(index == 3){
                if(index1 == 1){
                    this.title1 = '新增现金银行'
                    this.form1 =  this.$form.createForm(this)
                    record.openFlag = '1'
                    record.code = inCode
                    console.log(record)
                    this.model = Object.assign({},record)
                    this.$nextTick(() => {
                        this.form1.setFieldsValue(pick(this.model,'code','openFlag'))
                    });
                }else{
                    this.title1 = '编辑现金银行'
                    this.form1 =  this.$form.createForm(this)
                    this.model = Object.assign({},record)
                    this.$nextTick(() => {
                        this.form1.setFieldsValue(pick(this.model,'code','name','nameShort','id','openFlag','remark'))
                    });
                }
                this.isShowModel1 = true
            }else if(index == 4){

            }else if(index == 5){
                this.isShowModel2 = true
                this.form2 = this.$form.createForm(this)
                this.$nextTick(()=>{
                    let data =  this.getPreMonth(new Date().toLocaleDateString())
                    this.datetime = this.getTime()
                    this.form2.setFieldsValue({
                        startTime:moment(data),
                        endTime:moment(new Date().toLocaleDateString()),
                    })
                })
                this.model = record
            }else if(index == 6){
                this.isShowModel3 = true
                this.form3 = this.$form.createForm(this)
                this.model = record
            }
        },
        getPreMonth(date) {
            var arr = date.split('/');
            var year = arr[0]; //获取当前日期的年份
            var month = arr[1]; //获取当前日期的月份
            var day = arr[2]; //获取当前日期的日
            var days = new Date(year, month, 0);
            days = days.getDate(); //获取当前日期中月的天数
            var year2 = year;
            var month2 = parseInt(month) - 1;
            if (month2 == 0) {
                year2 = parseInt(year2) - 1;
                month2 = 12;
            }
            var day2 = day;
            var days2 = new Date(year2, month2, 0);
            days2 = days2.getDate();
            if (day2 > days2) {
                day2 = days2;
            }
            if (month2 < 10) {
                month2 = '0' + month2;
            }
            if (day2 < 10) {
                day2 = '0' + day2;
            }
            var t2 = year2 + '/' + month2 + '/' + day2;
            this.datetime1 = year2 + '-' + month2 + '-' + day2
            return t2;
        },
        disabledEndDate(endValue){
            if (!endValue) {
                return false;
            }
            return endValue.valueOf() > moment(new Date().toLocaleDateString()).valueOf();
        },
        onCofrimForm(){
            this.form.validateFields((err, values) => {
                if(!err){
                    values.companyStoreId = this.$store.state.shopId
                    values.companyId = this.$store.state.companyId
                    if(!this.isEmpty(this.model.id)){
                        values.id = this.model.id
                        financeUpdate(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel = false
                                this.$message.success(res.logMessage)
                                this.$emit('onPageList')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        financeAdd(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel = false
                                this.$message.success(res.logMessage)
                                this.$emit('onPageList')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }

                }
            })
        },
        onCancel(){
            this.isShowModel = false
            this.isShowModel1 = false
            this.isShowModel2 = false
            this.isShowModel3 = false
        },
        onCofrimForm1(){
            this.form1.validateFields((err, values) => {
                if(!err){
                    values.companyStoreId = this.$store.state.shopId
                    values.companyId = this.$store.state.companyId
                    if(this.isEmpty(this.model.id)){
                        finceaccountsave(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel1 = false
                                this.$message.success(res.logMessage)
                                this.$emit('finceList')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        values.id = this.model.id
                        finceaccountupdate(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel1 = false
                                this.$message.success(res.logMessage)
                                this.$emit('finceList')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }
                }
            })
        },
        onCofrimForm2(){
            this.form2.validateFields((err, values) => {
                if(!err){
                    this.isShowModel2 = false
                    let item = JSON.stringify({
                        id:this.model.id,
                        name:this.model.name,
                        startTime: this.datetime1,
                        endTime:this.datetime,
                    })
                    this.$router.push('/system/set/cashBankDetail?item='+encodeURIComponent(item))
                }
            })
        },
        onCofrimForm3(){
            this.form3.validateFields((err, values) => {
               if(!err){
                   values.companyStoreId = this.$store.state.shopId
                   values.companyId = this.$store.state.companyId
                   values.financeAccountId = this.model.id
                   updatebalance(values,{}).then((res)=>{
                        if(res.success){
                            this.$message.success('设置成功')
                            this.$emit('finceList')
                            this.isShowModel3 = false
                        }else{
                            this.$message.warn(res.logMessage)
                        }
                   })
               }
            })

        },
        changeDate(date, dateString){
            this.datetime = dateString
        },
        changeDate1(date, dateString){
            this.datetime1 = dateString
        },
        changeType(value){
            if(value == 1){
                this.form.setFieldsValue({
                    code:this.inCode
                })
            }else if(value == 2){
                 this.form.setFieldsValue({
                    code:this.outCode
                })
            }
        }
    },

}
</script>
<style  lang="scss">
.freight-model{
    width: 550px !important;
    height: 410px !important;
}
.freight-model1{
    width: 550px !important;
    height: 540px !important;
}
    .freight-model2{
        width: 550px !important;
        height: 360px !important;
    }
    .freight-model3{
        width: 520px !important;
        height: 280px !important;
    }
</style>
